export class ShopCartCalculator extends HTMLElement {
    freeShippingThreshold: number | null = null
    freeShippingNote: string | null = null
    freeShippingThresholdNote: string | null = null

    // Elements
    progressBarEl: HTMLElement | null = null
    remainingAmountEl: HTMLElement | null = null
    freeShippingContainerEl: HTMLElement | null = null
    shippingContainerEl: HTMLElement | null = null
    progressNoteEl: HTMLElement | null = null
    thresholdNoteEl: HTMLElement | null = null

    // Shipping price elements
    shippingPriceValueEl: HTMLElement | null = null
    shippingPriceFreeEl: HTMLElement | null = null

    // Calculated values
    remainingAmount: number | null = null
    progressPercentage: number = 0
    cartTotalPrice: number = 0

    hasFreeShipping: boolean = false

    constructor() {
        super()

        this.freeShippingThreshold = Number(this.getAttribute('free-shipping-threshold')) || 10000
        this.freeShippingNote = this.getAttribute('free-shipping-note')
        this.freeShippingThresholdNote = this.getAttribute('free-shipping-threshold-note')

        this.freeShippingContainerEl = this.querySelector<HTMLElement>('[data-free-shipping-container]')
        this.shippingContainerEl = this.querySelector<HTMLElement>('[data-shipping-container]')

        this.progressBarEl = this.querySelector<HTMLElement>('[data-progress-bar]')
        this.remainingAmountEl = this.querySelector<HTMLElement>('[data-remaining-amount]')
        this.progressNoteEl = this.querySelector<HTMLElement>('[data-progress-note]')
        this.thresholdNoteEl = this.querySelector<HTMLElement>('[data-threshold-note]')

        // These elements are not part of the component, but need to be updated
        this.shippingPriceValueEl = document.querySelector<HTMLElement>('[data-shipping-price-value]')
        this.shippingPriceFreeEl = document.querySelector<HTMLElement>('[data-shipping-price-free]')

        // @ts-ignore
        document.addEventListener('liquid-ajax-cart:request-end', this.handleAjaxCartRequestEnd.bind(this))
        // @ts-ignore
        document.addEventListener('liquid-ajax-cart:init', this.handleAjaxCartInit.bind(this))
    }

    private handleAjaxCartInit(evt: CustomEvent) {
        // @ts-ignore
        const cart = window?.liquidAjaxCart?.cart

        this.updateCartCalculator(cart)
    }

    // Cart update handler runs on liquid-ajax-cart:init and liquid-ajax-cart:request-end
    private handleAjaxCartRequestEnd(evt: CustomEvent) {
        const {
            cart,
            requestState: { requestType },
        } = evt.detail

        if (
            requestType === 'add' ||
            requestType === 'update' ||
            requestType === 'remove' ||
            requestType === 'init' ||
            requestType === 'change'
        ) {
            this.updateCartCalculator(cart)
        }
    }

    private updateCartCalculator(cart: any) {
        this.cartTotalPrice = cart.total_price
        this.hasFreeShipping = (this?.cartTotalPrice ?? 0) >= (this?.freeShippingThreshold ?? 0)

        const hasSellingPlan = cart.items.some((item: any) => item.selling_plan_allocation)

        if (this.hasFreeShipping || hasSellingPlan) {
            this?.remainingAmountEl?.classList.add('hidden')
            this.progressPercentage = 100
            this?.progressBarEl?.style.setProperty('width', '100%')

            this?.freeShippingContainerEl?.classList.add('hidden')
            this?.progressNoteEl?.classList.add('hidden')
            this?.thresholdNoteEl?.classList.remove('hidden')
            this?.shippingContainerEl?.classList.remove('hidden')

            this.shippingPriceValueEl?.classList.add('hidden')
            this.shippingPriceFreeEl?.classList.remove('hidden')

            return
        }

        const remainingAmount = ((this?.freeShippingThreshold ?? 0) - (this?.cartTotalPrice ?? 0)) / 100

        if (this?.remainingAmountEl) {
            this.remainingAmountEl.textContent = `$${remainingAmount?.toFixed(2)} left`
        }

        this.progressPercentage = ((this?.cartTotalPrice ?? 0) / (this?.freeShippingThreshold ?? 0)) * 100

        // update the progress bar

        this?.progressBarEl?.style.setProperty('width', `${this.progressPercentage}%`)

        this?.freeShippingContainerEl?.classList.remove('hidden')
        this?.progressNoteEl?.classList.remove('hidden')
        this?.thresholdNoteEl?.classList.add('hidden')

        this.shippingPriceValueEl?.classList.remove('hidden')
        this.shippingPriceFreeEl?.classList.add('hidden')
    }
}

customElements.define('shop-cart-calculator', ShopCartCalculator)
